/*
 * Developed by HuMingZhi on 1/20/19 3:51 PM
 * Copyright (c) 2019. All right reserved.
 *
 * cdn域名列表
 */
export var cdn = [
    'sf1-ttcdn-tos.pstatp.com',
    'sf3-ttcdn-tos.pstatp.com',
    'sf6-ttcdn-tos.pstatp.com'
];
